/*
|--------------------------------------------------------------------------
| Import
|--------------------------------------------------------------------------
*/

import { AmbientLight } from 'three';
import { SceneAdd } from '~/Scene';

/*
|--------------------------------------------------------------------------
| Locals
|--------------------------------------------------------------------------
*/

let _ambient: AmbientLight = null;

/*
|--------------------------------------------------------------------------
| Public Function
|--------------------------------------------------------------------------
*/

/**
 * @return {void}
 */
export function LightAmbientGet(): AmbientLight
{
    return _ambient;
}

/**
 * @return {void}
 */
export function LightAmbientInit(color: number = 0xFFFFFF, intensity: number = 0.5): void
{
    _ambient = new AmbientLight(color ?? 0xFFFFFF, intensity ?? 0.5);
    SceneAdd(_ambient);
}
